import Vue from 'vue'
import Vuex from 'vuex'
// import * as api from '../constants/index.js'
import * as types from './type'
// import * as http from '../utils/http.js'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    token:'',
    tokenTime:'',
    wxkey:'',
    wxkeyTime:'',
    tokenExprires: '',
    logining:false,//是否登录
    userInfo:'',
    isVerify:false,//是否人脸认证
    step:0,//认证步骤
    propertyMsg:{CQR:'', CQRZJHM:'', CQZH:'', LXDH:'', LXR:'',},//产权信息输入保存
    responseHouseMsg:'',//产权信息
    fillMsg:{ID:'', GPDZ:'', mapAddress:'', LAT:'', LNG:'', SZXQ:'', GPZJ:'', ZXQK:'', CX:'',YDT:'', ROOMS:'', HALLS:'', GUARDS:'', JTCS:'', SZC:'', FJDT:'', area:'', zxqkValue:'', cxValue:'', szcValue:'', fjdtValue:'', ydtValue:'',},//步骤3用户填写信息
    step4:{ID:'', BT:'', FWLD1:'', FWLD2:'', FWLD3:'',},//步骤4信息
    buyer:true,
    appointmentMsg:{system:'', systemId:'', item:'', itemId:'', date:'', time:'', userName:'', userPhone:'', userIdent:'', certificateNumber:'',contractNumber:'',certificateType:'',}, //预约信息填写
    faceBeforeRouter: '',
    agreeToken: '',
    enterValue: '',
  },
  getters: {
    responseHouseMsg: state => state.responseHouseMsg,
    propertyMsg: state => state.propertyMsg,
    fillMsg: state => state.fillMsg,
    step4: state => state.step4,
    logining: state => state.logining,
    userInfo: state => state.userInfo,
    isVerify: state => state.isVerify,
    buyer: state => state.buyer,
    appointmentMsg: state => state.appointmentMsg,
    faceBeforeRouter: state => state.faceBeforeRouter,
    agreeToken: state => state.agreeToken,
    enterValue: state => state.enterValue
  },
  mutations: {
    [types.SET_TOKEN] (state,res){
      state.token = res;
      localStorage.setItem('token',res);
    },
    [types.SET_TOKENTIME] (state,res){
      state.tokenTime = res;
      localStorage.setItem('tokenTime',res);
    },
    [types.SET_TOKEN_EXPRIRES] (state,res){
      state.tokenExprires = res;
      localStorage.setItem('tokenExprires',res);
    },
    [types.SET_LOGINING] (state,res){
      state.logining = res;
    },
    [types.SET_USER_INFO] (state,res){
      state.userInfo = res;
      localStorage.setItem('userInfo',JSON.stringify(res));
    },
    [types.SET_ISVERIFY] (state,res){
      state.isVerify = res;
      localStorage.setItem('isVerify',res);
    },
    [types.SET_STEP] (state,res) {
    	state.step =res
    },
    [types.SET_RESPONSE_HOUSEMSG] (state,res){
      state.responseHouseMsg = res;
      localStorage.setItem('responseHouseMsg',JSON.stringify(res));
    },
    [types.SET_PROPERTY_MSG] (state,res){
      state.propertyMsg = res;
    },
    [types.SET_FILL_MSG] (state,res){
      state.fillMsg = res;
      localStorage.setItem('fillMsg',JSON.stringify(res));
    },
    [types.SET_STEP4_MSG] (state,res){
      state.step4 = res;
    },
    [types.SET_BUYER] (state,res){
      state.buyer = res;
    },
    [types.SET_APPOINTMENT_MSG] (state,res){
      state.appointmentMsg = res;
    },
    [types.SET_FACEBEFORE_ROUTER] (state,res){
      state.faceBeforeRouter = res;
    },
    [types.SET_AGREE_TOKEN] (state,res){
      state.agreeToken = res;
    },
    SET_ENTER_VALUE (state,res){
      state.enterValue = res;
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js